// extracted by mini-css-extract-plugin
export default {"container":"education_container__e-alv","root":"education_root__n9LJ7"};